// extracted by mini-css-extract-plugin
export default {"facebook_link":"SocialsList_facebook_link__p-nOm","icon":"SocialsList_icon__N9zHp","icon_container":"SocialsList_icon_container__kRlfh"};